module.exports = __webpack_public_path__ + "img/3.1fb5d533.png";